import { createContext, useState } from "react";

export const blurContext = createContext({
	blur: false,
	changeBlurState: () => {},
});

export default function BlurContextProvider({ children }) {
	const [blur, setBlur] = useState(false);

	const changeBlurState = (blurstate) => {
		setBlur(blurstate);
	};

	return (
		<blurContext.Provider value={{ blur: blur, changeBlurState }}>
			{children}
		</blurContext.Provider>
	);
}
